<template>
    <myPage :max_flag="true">
        <div slot="header">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" icon="el-icon-refresh" @click="getLoad()">刷新</el-button>
                </el-button-group>
            </div>
            <div class="tcenter pd-bottom10 border-bottom-line-has">
                <el-input ref="txt_mobile" class="width-300" v-model="formData.mobile">
                    <span slot="prepend">手机号码</span>
                </el-input>
            </div>
        </div>
        <div class="fillw fillh" style="overflow-y: auto">
            <div class="flex-box nopadding wrap pd-top10" v-if="goods.length > 0">
                <div class="card-box bg2 round-10 width-250 mg-right10 mg-bottom10 hand hover-block" style="height: 100px"
                     v-for="(item,index) in goods" :key="item.goods_id" @click="add(item)">
                    <div class="flex-box pd-5" v-if="item.img_lnk != ''">
                        <div class="width-80">
                            <img class="img-80 round-5" :src="item.img_lnk">
                        </div>
                        <div class="flex-box-bd tleft mg-left5 over-hide">
                            <div class="f-bd text-nowrap">{{item.goods_cname}}</div>
                            <div class="f-red mg-top10" v-if="item.cost_amt != ''">
                                <span class="f18 mg-right3">{{item.cost_amt * 1}}</span>元
                            </div>
                        </div>
                    </div>
                    <div class="flex-box col-center fillh" v-else>
                        <div class="flex-box-bd"></div>
                        <div class="f-bd text-nowrap">{{item.goods_cname}}</div>
                        <div class="f-red mg-top10" v-if="item.cost_amt != ''">
                            <span class="f18 mg-right3">{{item.cost_amt * 1}}</span>元
                        </div>
                        <div class="flex-box-bd"></div>
                    </div>
                </div>
            </div>
            <div v-else>
                <myNodata></myNodata>
            </div>
        </div>
    </myPage>
</template>

<script>
import myNodata from '../../../components/myNodata'
import request from "../../../utils/request_api";
export default {
    name:'charge-mobile',
    components:{
        myNodata
    },
    data:function(){
        return{
            formData:{
                mobile:'',
                goods_id:''
            },
            goods:[]
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
        this.$nextTick(()=>{
            this.$refs.txt_mobile.focus();
        });
    },
    mounted: function(){
        this.$base.setMenuOpens();
        this.getLoad();
    },
    methods:{
        getLoad: function(){
            this.$base.showLoading();
            this.$request.sendPost("order-c/before-add", {},(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.goods = data.goods;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        add: function(item){
            if(this.formData.mobile == ""){
                this.$base.msgErr('请输入需要充值的手机号码');
                return;
            }

            this.$base.confirm('手机号：'+this.formData.mobile + '，充值：'+(item.new_price * 1)+'元',()=>{
                this.formData.goods_id = item.goods_id;
                this.formData.goods_amt = item.new_price;
                this.$base.showLoading();
                this.$request.sendPost("order-c/add", this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        // this.$base.showLoading('下单成功，正在获取充值结果');
                        // this.$base.chkOrderCharge(data.order_code,(data)=>{
                        //     this.$base.hideLoading();
                        //     this.$nextTick(()=>{
                        //         this.$base.alertSuccess('充值结果：' + data.order_status_cdesc,()=>{
                        //             this.formData.mobile = "";
                        //         });
                        //     });
                        // });
                        this.formData.mobile = "";
                        this.$base.msgSuccess('下单成功，可前往订单管理查询订单状态');
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            });
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/charge/mobile/list.vue